














































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PushNotifConfirmModal extends Vue {
  @Prop({ default: 'Envoi de notification push' })
  public title!: string;

  @Prop({ default: 'Vous allez envoyer une notification aux terminaux LEA.' })
  public content!: string;
  @Prop()
  public notifyAction?: any;

  public isNotifying = false;

  public async notify(): Promise<void> {
    this.isNotifying = true;
    if (this.notifyAction) {
      const notified = await this.notifyAction();

      if (notified) {
        this.$emit('close');
      }
    } else {
      this.$emit('close');
    }
    this.isNotifying = false;
  }
}
